import { StringEnum, type StringEnumType } from '@yp/common/enums.ts';
import { isAbsent } from '@yp/common/identity.ts';

export const NameStyles = new StringEnum('full-first', 'full-last', 'casual');
export type NameStyle = StringEnumType<typeof NameStyles>;

export function nameOf(
  person?: { first?: string | undefined; last?: string | undefined },
  style: NameStyle = 'full-first',
  defaultName = 'Unknown',
): string {
  if (isAbsent(person?.first)) {
    if (isAbsent(person?.last)) {
      return defaultName;
    } else {
      return person.last;
    }
  }
  if (isAbsent(person.last)) {
    return person.first;
  }
  switch (style) {
    default:
    case 'full-first':
      return `${person.first} ${person.last}`;
    case 'full-last':
      return `${person.last}, ${person.first}`;
    case 'casual':
      return person.first;
  }
}
